<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <!-- 구입상품추가 그리드 s.-->
            <div class="table-area">
                <div class="table-b">
                    <div class="table-header">
                        <div class="table-name">
                            <h3 class="ico_table_name">{{ `구입상품` }}</h3>
                        </div>
                    </div>
                    <div class="grid-tbl-box">
                        <ag-grid-vue 
                            ref="grid" 
                            :style="gridStyle"
                            class="ag-theme-alpine"
                            enableRangeSelection="true"
                            :column-defs="columnDefs"
                            :grid-options="gridOptions"
                            :row-data="rowData"
                            :default-col-def="defaultColDef"
                            :framework-components="frameworkComponent"
                            @grid-ready="onReady"
                            @cell-clicked="onCellClicked" />
                    </div>
                </div>
            </div>
            <!-- 구입상품추가 그리드 e.-->
            <!-- 결제방법 form s.-->
            <div class="table-area">
                <div class="table-b">
                    <div class="el-search-form">
                        <el-form size="mini" label-width="80px">
                            <el-row :gutter="24">
                                <el-col :span="12">
                                    <div class="sub-title">
                                        <div class="table-name">
                                            <h3 class="ico_table_name">{{ `결제방법` }}</h3>
                                        </div>
                                    </div>
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="주문번호">
                                                <el-input type="text" v-model="form.orderId" readonly></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="24">
                                        <el-col :span="12">
                                            <el-form-item label="주문일시">
                                                <el-input type="text" v-model="form.orderDt" readonly></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="청구금액">
                                                <el-input type="text" v-model="form.orderAmt" readonly></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="24">
                                        <el-col :span="12">
                                            <el-form-item label="주문자명">
                                                <el-input type="text" v-model="form.custNm" readonly></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-row>
                                                <el-form-item label="입금은행">
                                                    <el-col :span="24">
                                                        <el-select v-model="form.payBank">
                                                            <el-option
                                                            v-for="item in payBankOpt"
                                                            :key="item.key"
                                                            :value="item.key"
                                                            :label="item.value" disabled>
                                                            </el-option>
                                                        </el-select>
                                                    </el-col>
                                                </el-form-item>
                                            </el-row>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="24">
                                        <el-col :span="12">
                                            <el-form-item label="연락처">
                                                <el-input type="text" v-model="form.orderTelNo" readonly></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-row>
                                                <el-form-item label="계산서발행">
                                                    <el-col :span="24">
                                                        <el-radio-group v-model="form.billYn">
                                                            <el-radio 
                                                                v-for="item in billYnRadio"
                                                                :key="item.value"
                                                                :label="item.key"
                                                                :value="item.value" disabled>{{ item.value }}
                                                            </el-radio>
                                                        </el-radio-group>
                                                    </el-col>
                                                </el-form-item>
                                            </el-row>
                                        </el-col>
                                    </el-row>
                                    <div class="grid-content bg-purple"></div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="sub-title">
                                        <div class="table-name">
                                            <h3 class="ico_table_name">{{ `배송지` }}</h3>
                                        </div>
                                    </div>
                                    <el-row>
                                        <el-col>
                                            <el-form-item label="받을사람">
                                                <el-input type="text" v-model="form.deliveryNm" readonly></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="24">
                                        <el-col :span="12">
                                            <el-form-item label="전화번호">
                                                <el-input type="text" v-model="form.deliveryTelNo" readonly></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="핸드폰">
                                                <el-input type="text" v-model="form.deliveryHpNo" readonly></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="24">
                                        <el-col>
                                            <el-form-item label="주소">
                                                <el-row>
                                                    <el-col>
                                                        <el-row>
                                                            <el-col :span="7">
                                                                <el-input type="text" v-model="form.zipCd1" readonly></el-input>
                                                            </el-col>
                                                            <el-col :span="17">
                                                                <el-input type="text" v-model="form.addr1" readonly></el-input>
                                                            </el-col>
                                                        </el-row>
                                                    </el-col>
                                                </el-row>
                                                <el-row>
                                                    <el-col>
                                                        <el-row :gutter="24">
                                                            <el-col :span="24">
                                                                <el-input type="text" v-model="form.addr2" readonly></el-input>
                                                            </el-col>
                                                        </el-row>
                                                    </el-col>
                                                </el-row>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-- 결제방법 form e.-->
            <!-- 주문메모 text area s.-->
            <div class="table-area">
                <div class="table-b" style="margin-bottom: 0px;">
                    <el-row :gutter="24">
                        <el-col>
                            <div class="sub-title">
                                <div class="table-name">
                                    <h3 class="ico_table_name">{{ `주문메모` }}</h3>
                                </div>
                            </div>
                            <el-input
                            type="textarea"
                            :autosize="{ minRows: 4, maxRows: 6}"
                            v-model="form.memo"  readonly>
                            </el-input>
                            <div class="grid-content bg-purple"></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 주문메모 text area e.-->
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
/**
 * * components
 */
import {AgGridVue} from 'ag-grid-vue';
import MaskEditCellRenderer from '@/components/agGrid/maskedit-cell-renderer'    

/**
 * * mixins
 */
import Modal from '../index.js';
import common from '@/mixin/lucoms';

/**
 * 콤마표시
 * @param {*} val 
 */
function comma(val){
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

 export default {
    components: {Layout, AgGridVue},
    props: {
        data: {
            type: Object,
            required: false
        }
    },
    mixins: [Modal, common],
    data() {
        return {
            form: {
                orderId: '', /** 주문번호 */             
                orderDt: '', /** 주문일시 */
                orderAmt: '0', /** 청구금액 */
                orderCustNm: '', /** 주문자명 */
                payBank: '', /** 입금은행 */
                payAccount: '', /** 계좌번호 */
                telNo: '', /** 연락처 */
                deliveryNm: '', /** 받을사람 */
                deliveryTelNo: '', /** 전화번호 */
                deliveryHpNo: '', /** 핸드폰 */
                zipCd1: '', /** 우편번호1 */
                addr1: '', /** 주소1 */
                addr1: '', /** 주소2 */
                memo: '', /** 주문메모 */
                billYn: '' /** 계산서 발생유무 */
            },
            payBankOpt: [], /** 입금은행 */
            billYnRadio: [], /** 계산서 발생유무 */
            qtyChangeCnt: 0,
            // AG-GRID OPTION [START]
            rowData: [],
            gridStyle : 'width: 100%;height: 200px; min-height:100px;',
            defaultColDef: {
                resizable: true
                , filter:false
                , sortable: true
            },
            gridApi: null,
            columnApi: null,
            columnDefs: [],
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            frameworkComponent : {
                maskEdit: MaskEditCellRenderer,
            },
            //AG-GRID OPTION [END]
        }
    },
    computed: {
        title() {
            return `주문상담상세내역`;
        }
    },
    mounted() {
        
        this.getCombo();
        this.createColumnDefs();
        this.selectOrderDetail();
        const vOrderAmt = this.form.orderAmt;
        this.form.orderAmt = comma(vOrderAmt);

        console.log('pop mount data: ', this.data, this.billYnRadio)
        
    },
    methods: {
        onReady(params) {
            //그리드용 api 정의
            this.gridApi = params.api;
            this.columnApi = params.columnApi;

            //this.gridApi.sizeColumnsToFit();
        },
        createColumnDefs() {
            const vm = this;
            this.columnDefs = [
                {
                    headerName:'No',
                    field:'순번', 
                    width:50,
                    cellStyle:{textAlign: 'center'},
                    valueFormatter: function(params) {               
                        return params.node.rowIndex+1;
                    }
                },
                {
                    headerName:'제조사',
                    field:'makerNm', 
                    width:110,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'제품군',
                    field:'itemGroupNm', 
                    width:110,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'상품코드',
                    field:'itemCd', 
                    width:110,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'상품명',
                    field:'itemNm', 
                    width:200,
                    cellStyle:{textAlign: 'center'},
                },
                {
                    headerName:'단가',
                    field:'unitPrice', 
                    width:110,
                    cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    }
                },
                {
                    headerName:'수량',
                    field:'qty', 
                    width:80,
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    }
                },
                {
                    headerName:'금액',
                    field:'amt', 
                    width:100,
                    cellStyle:{textAlign: 'right'},
                    valueFormatter: (params) => {
                        return vm.getNumberFormat(params.value);
                    }
                },
                {
                    headerName:'상품코드',
                    field:'itemId', 
                    hide: true,
                    width:100,
                    cellStyle:{textAlign: 'center'},
                },
            ];
        },
        onCellClicked(params) {
          const idx = params.rowIndex;
          const field = params.colDef.field;
        },
        selectOrderDetail(){
            const vm = this
            if(!this.data.orderId){
                return false
            }

            const vform = {
                orderId: this.data.orderId,
                sortType: ''
            }
            this.$store.commit('loading');
            // console.log('selectOrderDetail : ', vform) 
            this.$http.post(("/api/asMng/call/searchOrderDetailList"), vform
                ).then(response => {
                console.log('selectOrderDetail resp: ', response);
                this.rowData = response.data.callOrderDetailSelList;

                vm.form = JSON.parse(JSON.stringify(vm.data));
                const vMasterObj = response.data.callOrderMstSelMasterList;
                const vDeliveryObj = response.data.callOrderMstSelDeliveryList;
                const vDetailObj = response.data.callOrderMstSelList;
                
                if(vMasterObj && vMasterObj.length>0){
                    // 결재방법

                    vm.form.orderDt = vMasterObj[0].callDt && vMasterObj[0].callDt.length>=16? vMasterObj[0].callDt.substring(0,16) : '';     // 주문일시
                    vm.form.orderAmt = comma(vMasterObj[0].orderAmt);  // 청구금액
                    vm.form.custNm = vMasterObj[0].boundCustNm; // 주문자명
                    vm.form.orderTelNo = vm.form.orderTelNo ? _phone(vm.form.orderTelNo) : ''; // 연략처
                    vm.form.billYn = vMasterObj[0].billYn;      // 계산서발행

                }

                if(vDeliveryObj && vDeliveryObj.length>0){
                    // 배송지

                    vm.form.deliveryNm = vDeliveryObj[0].deliveryNm;        // 받을사람
                    vm.form.deliveryTelNo = vDeliveryObj[0].deliveryTelNo;   // 전화번호
                    vm.form.deliveryHpNo = vDeliveryObj[0].deliveryHpNo;    // 핸드폰
                    vm.form.zipCd1 = vDeliveryObj[0].zipCd;
                    vm.form.addr1 = vDeliveryObj[0].addr1;                  // 주소1
                    vm.form.addr2 = vDeliveryObj[0].addr2;                  // 주소2

                    vm.form.deliveryTelNo = vm.form.deliveryTelNo ? _phone(vm.form.deliveryTelNo) : '';
                    vm.form.deliveryHpNo = vm.form.deliveryHpNo ? _phone(vm.form.deliveryHpNo) : '';
                }
                
                
            }).finally(() => {
                this.$store.commit('finish');
            });
      },
      getCombo(param) {
        // 결제은행 : PayBank 2레벨
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 106}})
            .then(response => {
                this.payBankOpt = response.data || []
                this.payBankOpt.unshift({key:'', value:'선택'})

            });
        
        // 계산서발행유무 : BillYn 2레벨
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 131}})
            .then(response => {
                this.billYnRadio = response.data || []

                // console.log('billYnRadio response.data: ', response.data)
            });    
    
        },

    }
 }

</script>

<style lang="scss" scoped>
.modal .pop-content{
    padding: 0px 26px 25px 26px;
}
</style>